var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73926 15.5762H16.833C18.3584 15.5762 19.2607 14.6738 19.2607 12.8691V4.23242C19.2607 2.42773 18.3477 1.53613 16.5215 1.53613H8.47559C7.94922 1.53613 7.60547 1.38574 7.19727 1.05273L6.66016 0.623047C6.10156 0.161133 5.63965 0 4.82324 0H2.41699C0.902344 0 0 0.880859 0 2.6748V12.8691C0 14.6738 0.913086 15.5762 2.73926 15.5762ZM2.76074 14.0186C1.9873 14.0186 1.54688 13.6104 1.54688 12.7939V2.75C1.54688 1.95508 1.97656 1.54688 2.75 1.54688H4.41504C4.94141 1.54688 5.28516 1.69727 5.69336 2.03027L6.23047 2.45996C6.77832 2.91113 7.25098 3.08301 8.06738 3.08301H16.5C17.2734 3.08301 17.7139 3.50195 17.7139 4.31836V12.8047C17.7139 13.6104 17.2734 14.0186 16.5 14.0186H2.76074ZM0.945312 6.14453H18.3047V4.69434H0.945312V6.14453Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.df8c30290e2d77e1a4a31dcf8d9b08d3.svg";
export { ForwardRef as ReactComponent };